export const CUSTOMER_PORTAL_SESSION_KEY = "customerPortalSession";

/** @deprecated legacy flag; cleared on logout */
export const CUSTOMER_PORTAL_AUTH_KEY = "customerPortalAuthenticated";

export function initialsFromName(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function getCustomerPortalSession() {
  try {
    const raw = sessionStorage.getItem(CUSTOMER_PORTAL_SESSION_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.token || Number(data?.user?.role_id) !== 6) return null;
    return data;
  } catch {
    return null;
  }
}

export function setCustomerPortalSession(apiResponse) {
  const user = {
    id: apiResponse.id,
    full_name: apiResponse.full_name,
    email: apiResponse.email,
    role_id: apiResponse.role_id,
    salon_id: apiResponse.salon_id,
    profile_photo_url: apiResponse.profile_photo_url,
  };
  sessionStorage.setItem(
    CUSTOMER_PORTAL_SESSION_KEY,
    JSON.stringify({
      token: apiResponse.token,
      auth_key: apiResponse.auth_key,
      user,
    }),
  );
}

export function clearCustomerPortalSession() {
  sessionStorage.removeItem(CUSTOMER_PORTAL_SESSION_KEY);
  sessionStorage.removeItem(CUSTOMER_PORTAL_AUTH_KEY);
}
